import { z } from 'zod';
import { ROLES, TIERS, USER_STATUSES } from '../constants.js';
import { paginationQuerySchema } from './common.js';
export const createUserSchema = z.object({
    fullName: z.string().trim().min(2, 'Name is required').max(120),
    /** Where the login OTP is delivered. Must be a mailbox the person controls. */
    email: z.string().trim().toLowerCase().email('A valid email is required').max(255),
    phone: z.string().trim().max(32).optional().or(z.literal('')),
    company: z.string().trim().max(120).optional().or(z.literal('')),
    notes: z.string().trim().max(2000).optional().or(z.literal('')),
    role: z.enum(ROLES).default('USER'),
    tier: z.enum(TIERS).default('FREE'),
    /**
     * Also email the generated credentials to the user. Off by default — the
     * intended flow is that the admin hands them over out-of-band.
     */
    sendCredentialsEmail: z.boolean().default(false),
});
/** Admins only ever list end users, so there is no role filter to apply. */
export const listUsersQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(120).optional(),
    status: z.enum(USER_STATUSES).optional(),
    sort: z.enum(['createdAt', 'lastLoginAt', 'fullName', 'uid']).default('createdAt'),
    order: z.enum(['asc', 'desc']).default('desc'),
});
//# sourceMappingURL=admin.js.map